import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { SchedulerService } from '../../../../services/scheduler/scheduler.service';

@Component({
  selector: 'app-time-range-dialog',
  imports: [MatButtonModule, NgxMatTimepickerModule, MatChipsModule, MatFormFieldModule, CommonModule, ReactiveFormsModule, MatInputModule, MatDialogModule, MatToolbarModule, MatIconModule],
  templateUrl: './time-range-dialog.component.html',
  styleUrl: './time-range-dialog.component.css'
})
export class TimeRangeDialogComponent implements AfterViewInit {
  @ViewChild('startInput') startInput!: ElementRef<HTMLInputElement>;
  scheduleServer : SchedulerService = inject(SchedulerService);

  timeRangeForm: FormGroup;
  start : FormControl = new FormControl(0, Validators.required);
  end : FormControl = new FormControl(0, Validators.required);
  errorMessage : string = '';

  constructor(
    public dialogRef: MatDialogRef<TimeRangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { start: number, end: number }
  ) {
    this.start.setValue(this.scheduleServer.minutesToTime(data.start));
    this.end.setValue(this.scheduleServer.minutesToTime(data.end));

    this.timeRangeForm = new FormGroup({
      start: this.start,
      end: this.end
    });

    this.timeRangeForm.valueChanges.subscribe(() => { setTimeout(() => this.validate(), 0) });
  }



  save() {
    const { start, end } = this.timeRangeForm.value;

    if (this.validate()) {

      this.dialogRef.close({ 
          fromTime: this.scheduleServer.timeToMinutes(start), 
          toTime: this.scheduleServer.timeToMinutes(end) });

    }

  }

  close() {
    this.dialogRef.close();
  }

  get formattedSelectedRange(): string {
    const start = this.timeRangeForm.value.start;
    const end = this.timeRangeForm.value.end;
    return start && end ? `${start} → ${end}` : '';
  }

  validate() : boolean{
    this.errorMessage = '';

    if (!this.start.valid || !this.end.valid) {
      this.errorMessage = 'Invalid time format';
      return false;
    }

    var starMin = this.scheduleServer.timeToMinutes(this.start.value);
    var endMin = this.scheduleServer.timeToMinutes(this.end.value);

    if (endMin <= starMin) {
      this.errorMessage = 'End time must be after start time';
      return false
    }

    return true;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.startInput.nativeElement.focus();
    }, 0);
  }

}
